module.exports = __webpack_public_path__ + "img/icon-decoration.8bb5f0b4.svg";